import {
  AttributeValue,
  DynamoDBClient,
  KeysAndAttributes,
} from '@aws-sdk/client-dynamodb'
import { DynamoDBDocumentClient } from '@aws-sdk/lib-dynamodb'
import { Table } from 'dynamodb-toolbox'
import { isEmpty } from 'lodash'

export const getTableName = (envVariableName: string): string => {
  const tableName = process.env[envVariableName] || 'undefined_table_name'
  return tableName
}

const marshallOptions = {
  // Whether to remove undefined values while marshalling.
  removeUndefinedValues: true, // false, by default.
  // Whether to convert typeof object to map attribute.
  convertClassInstanceToMap: true, // false, by default.
}

const unmarshallOptions = {
  // Whether to return numbers as a string instead of converting them to native JavaScript numbers.
  // NOTE: this is required to be true in order to use the bigint data type.
  wrapNumbers: false, // false, by default.
}

export const translateConfig = { marshallOptions, unmarshallOptions }

// Instantiate a DocumentClient
const DocumentClient = DynamoDBDocumentClient.from(
  new DynamoDBClient({}),
  translateConfig,
)

export const getToolboxTable = (
  tableName: string,
  documentClient?: DynamoDBDocumentClient,
) => {
  return new Table({
    documentClient: documentClient ? documentClient : DocumentClient,
    name: tableName,
    partitionKey: {
      name: 'pk',
      type: 'string',
    },
    sortKey: {
      name: 'sk',
      type: 'string',
    },
    indexes: {
      gsi1: {
        type: 'global',
        partitionKey: {
          name: 'gsi_1_pk',
          type: 'string',
        },
        sortKey: {
          name: 'gsi_1_sk',
          type: 'string',
        },
      },
      gsi2: {
        type: 'global',
        partitionKey: {
          name: 'gsi_2_pk',
          type: 'string',
        },
        sortKey: {
          name: 'gsi_2_sk',
          type: 'string',
        },
      },
      gsi3: {
        type: 'global',
        partitionKey: {
          name: 'gsi_3_pk',
          type: 'string',
        },
        sortKey: {
          name: 'gsi_3_sk',
          type: 'string',
        },
      },
      gsi4: {
        type: 'global',
        partitionKey: {
          name: 'gsi_4_pk',
          type: 'string',
        },
        sortKey: {
          name: 'gsi_4_sk',
          type: 'string',
        },
      },
      gsi5: {
        type: 'global',
        partitionKey: {
          name: 'gsi_5_pk',
          type: 'string',
        },
        sortKey: {
          name: 'gsi_5_sk',
          type: 'string',
        },
      },
      gsi6: {
        type: 'global',
        partitionKey: {
          name: 'gsi_6_pk',
          type: 'string',
        },
        sortKey: {
          name: 'gsi_6_sk',
          type: 'string',
        },
      },
      gsi7: {
        type: 'global',
        partitionKey: {
          name: 'gsi_7_pk',
          type: 'string',
        },
        sortKey: {
          name: 'gsi_7_sk',
          type: 'string',
        },
      },
      gsi8: {
        type: 'global',
        partitionKey: {
          name: 'gsi_8_pk',
          type: 'string',
        },
        sortKey: {
          name: 'gsi_8_sk',
          type: 'string',
        },
      },
      gsi9: {
        type: 'global',
        partitionKey: {
          name: 'gsi_9_pk',
          type: 'string',
        },
        sortKey: {
          name: 'gsi_9_sk',
          type: 'string',
        },
      },
    },
  })
}

// Instantiate a table
export const WebsocketTable = getToolboxTable(
  getTableName('WEBSOCKET_TABLE_NAME'),
  DocumentClient,
)
export const ApplicationTable = getToolboxTable(
  getTableName('APPLICATION_TABLE_NAME'),
  DocumentClient,
)

export const encodeNextToken = (
  lastEvaluatedKey:
    | Record<string, AttributeValue>
    | Record<string, KeysAndAttributes>
    | undefined,
): string | undefined => {
  if (isEmpty(lastEvaluatedKey)) return undefined
  const stringifiedToken = JSON.stringify(lastEvaluatedKey)
  return Buffer.from(stringifiedToken).toString('base64')
}

export const decodeNextToken = (
  exclusiveStartKey: string | undefined,
):
  | Record<string, AttributeValue>
  | Record<string, KeysAndAttributes>
  | undefined => {
  if (!exclusiveStartKey) {
    return undefined
  }
  const decodedToken = Buffer.from(exclusiveStartKey, 'base64').toString()
  return JSON.parse(decodedToken)
}
